import clsx from "clsx";
import React, { FC } from "react";

import { useAuthContext } from "../../../../../auth";
import { HeaderMenuItemCloseButton } from "../../header-menu-item-close-button";
import { PersonalAreaAuthenticated } from "./personal-area-authenticated";
import { PersonalAreaUnauthenticated } from "./personal-area-unauthenticated";

export interface PersonalAreaSpecialItemProps {
  className?: string;
  node_locale: string;
}

export const PersonalAreaSpecialItem: FC<PersonalAreaSpecialItemProps> = ({
  className,
  node_locale,
}) => {
  const { logged, userInfo } = useAuthContext();
  return (
    <div className={clsx("flex flex-col gap-4 w-full relative", className)}>
      <div className="flex justify-end">
        <HeaderMenuItemCloseButton />
      </div>

      <div>
        {logged ? (
          <PersonalAreaAuthenticated node_locale={node_locale} isCorporate={!!userInfo?.idp} />
        ) : (
          <PersonalAreaUnauthenticated />
        )}
      </div>
    </div>
  );
};
